import { Component, inject } from '@angular/core';
import { FeatureFlagEnum } from '@models/enums/feature-flag.enum';
import { CmsService } from '@services/cms/cms.service';
import { FeatureFlagService } from '@services/feature-flag/feature-flag.service';
import { TokenReplacePipe } from '@pipes/token-replace/token-replace.pipe';
import { NgTemplateOutlet } from '@angular/common';
import { LinkComponent } from '@components/link/link.component';
import { RouterLink } from '@angular/router';
import { PhoneMaskPipe } from '@pipes/phone-mask/phone-mask.pipe';
import { PhoneHrefPipe } from '@pipes/phone-href/phone-href.pipe';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    TokenReplacePipe,
    NgTemplateOutlet,
    LinkComponent,
    PhoneHrefPipe,
    PhoneMaskPipe,
    RouterLink,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  cmsService = inject(CmsService);
  featureFlagService = inject(FeatureFlagService);

  FeatureFlagEnum = FeatureFlagEnum;
  currentYear: number = new Date().getFullYear();
}
